import script from "./DiagramEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiagramEditorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DiagramEditorDialog.vue?vue&type=style&index=0&id=58bb9507&lang=css"

const __exports__ = script;

export default __exports__